import { Routes, Route } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

import Header from "./components/Header";
import Home from "./pages/Home";
import About from "./pages/About";
import Surveys from "./pages/Surveys";
import Login from "./pages/Login";
import Footer from "./components/Footer/Footer";
import Privacy from "./pages/Privacy";
import SurveyView from "./components/SurveyView";
import SurveyPage from "./components/SurveyPage";
import SurveyFinish from "./components/SurveyFinish";
import CreateSurvey from "./pages/CreateSurvey";
import EditSurvey from "./components/EditSurvey";
import Results from "./pages/Results";
import './App.css';



export default function App() {
  const [rehydrateKey, setRehydrateKey] = useState(0);
  const lastBumpRef = useRef(0);

  const location = useLocation();
  const navType = useNavigationType();

  const isIOS = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const iOS = /iPad|iPhone|iPod/.test(ua);
    const iPadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    return iOS || iPadOS;
  };

  const bump = (reason) => {
    const now = Date.now();
    if (now - lastBumpRef.current < 300) return; // throttle
    lastBumpRef.current = now;
    setRehydrateKey((k) => k + 1);
  };

  useEffect(() => {
    const onPageShow = (e) => {
      if (e.persisted) {
        bump("pageshow-persisted");
        return;
      }
      const nav = performance.getEntriesByType?.("navigation")?.[0];
      if (nav && nav.type === "back_forward") bump("pageshow-back_forward");
    };

    const onPageHide = (e) => {
      // Mark that we entered BFCache on iOS (some WebKit versions misreport pageshow.persisted)
      if (e.persisted && isIOS()) {
        try {
          sessionStorage.setItem("__bfcache_flag__", "1");
        } catch { }
      }
    };

    const onVisibility = () => {
      if (document.visibilityState === "visible" && isIOS()) {
        bump("visibility-visible");
      }
    };

    window.addEventListener("pageshow", onPageShow);
    window.addEventListener("pagehide", onPageHide);
    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("focus", onVisibility);

    // Fallback: if we detect earlier pagehide persisted, force a bump now
    try {
      if (isIOS() && sessionStorage.getItem("__bfcache_flag__") === "1") {
        sessionStorage.removeItem("__bfcache_flag__");
        bump("bfcache-flag");
      }
    } catch { }

    return () => {
      window.removeEventListener("pageshow", onPageShow);
      window.removeEventListener("pagehide", onPageHide);
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("focus", onVisibility);
    };
  }, []);

  // Force remount on history POP (Back/Forward) as an additional safety net
  useEffect(() => {
    if (navType === "POP") {
      bump("rrd-pop");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navType, location.pathname, location.search, location.hash]);

  // Last-resort fallback: disable BFCache on iOS by registering an unload listener (only iOS)
  useEffect(() => {
    if (!isIOS()) return;
    const noop = () => { };
    window.addEventListener("unload", noop);
    return () => window.removeEventListener("unload", noop);
  }, []);
  return (
    <>
      <Header />
      <main>
        <Routes key={rehydrateKey}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/login" element={<Login />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/results" element={<Results />} />

          <Route path="/surveys" element={<Surveys />} />
          <Route path="/surveys/:id" element={<SurveyView />} />
          <Route path="/surveys/:id/page/:page" element={<SurveyPage />} />
          <Route path="/surveys/:id/finish" element={<SurveyFinish />} />

          <Route path="/create-survey" element={<CreateSurvey />} />
          <Route path="/create-survey/:id" element={<EditSurvey />} />
        </Routes >
      </main >
      <Footer />
    </>
  )
}


